(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.factory('AccountSettingsService', [
        'UserApiConsumerService',
        '$q',
        'GetFetchService',
        function(
            UserApiConsumerService,
            $q,
            GetFetchService
        ) {
            var _pub = {};

            /**
             * Makes two API calls to save the first name, last name
             * and addresses of the user
             *
             * @param accountInfo
             * @returns {*}
             */
            _pub.save = function(accountInfo, addresses) {
                addresses = addresses || null;
                var profileUrl = 'api/1.0/user-profile/';
                var addressUrl = 'api/1.0/user-profile/address/';
                var requests = [UserApiConsumerService.put(profileUrl, accountInfo)];

                if (addresses !== null) {
                    requests.push(UserApiConsumerService.post(addressUrl, addresses));
                }

                return $q.all(requests);

            };

            /**
             * Gets currently logged-in user's info
             *
             * @param {Boolean} [force=false] If true, forces a re-fetch of the data
             * @returns {*}
             */
            _pub.getAccountInfo = function (force) {
                var urlOptions = {
                    url: 'api/1.0/user-profile/',
                    requestingService: UserApiConsumerService.request
                };
                return GetFetchService.get('user-profile', urlOptions, {force: force});
            };

            /**
             * Deletes the address info based on the given id
             *
             * @param addressInfo
             * @param id
             * @returns {*}
             */
            _pub.deleteAddress = function(id) {
                var url = 'api/1.0/user-profile/address/' + id + '/';
                return UserApiConsumerService.delete(url);
            };

            /**
             * Gets currently logged-in user's address info
             *
             * @param {Boolean} [force=false] If true, forces a re-fetch of the data
             * @returns {*}
             */
            _pub.getAddressInfo = function (force) {
                var urlOptions = {
                    url: 'api/1.0/user-profile/address/',
                    requestingService: UserApiConsumerService.request
                };
                return GetFetchService.get('user-profile-address', urlOptions, {force: force});
            };

            _pub.sendEmailVerification = function () {
                return UserApiConsumerService.get('api/1.0/account-send-email/');
            };


            return _pub;
        }
    ]);

})(angular);
